import React from 'react';
import '@fontsource/castoro/400-italic.css';
import '@fontsource/livvic';

export function wrapPageElement({ element, props }) {
  return <>{element}</>;
}
